<template>
	<PlaceholderPanel class="no-krs-placeholder">
		<template #title>{{ translate( "title" ) }}</template>
		<template #body>
			<p>{{ translate( "description1" ) }}</p>
			<p>{{ translate( "description2" ) }}</p>
		</template>
		<template #footer>
			<TeamingButton
				class="no-krs-placeholder__button"
				:disabled="disabled"
				:size="buttonSize"
				@click="$emit( `newKeyResult` )"
			>
				{{ translate( "newKeyResultButtonText" ) }}
			</TeamingButton>
		</template>
	</PlaceholderPanel>
</template>

<script>
import { ViewportMixin, TeamingButton } from "@teaming/common-ui";
import PlaceholderPanel from "../Common/PlaceholderPanel";

export default {
	name: "NoKRsPlaceholder",
	mixins: [ ViewportMixin, ],
	emits: [ "newKeyResult", ],
	components: {
		PlaceholderPanel,
		TeamingButton,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.NoKRsPlaceholder.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
.no-krs-placeholder__button {
	flex: 1;

	@include for-size('md') {
		flex: unset;
	}
}

.no-krs-placeholder__error {
	@include font-and-line-for(-1);
	color: $validation-error;
}
</style>
